import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=5a08c6a5&scoped=true&"
import script from "./AccountSecurity.vue?vue&type=script&lang=js&"
export * from "./AccountSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=5a08c6a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08c6a5",
  null
  
)

export default component.exports